export const resourceFileColumns = [
  {
    title: 'Resource ID',
    dataIndex: 'resourceId',
    key: 'resourceId',
    align: 'center',
    width: 100,
  },
  {
    title: 'Employee Number',
    dataIndex: 'employeeNumber',
    key: 'employeeNumber',
    align: 'center',
    width: 100,
  },
  {
    title: 'First Name',
    dataIndex: 'firstName',
    key: 'firstName',
    align: 'center',
    width: 120,
  },
  {
    title: 'Last Name',
    dataIndex: 'lastName',
    key: 'lastName',
    align: 'center',
    width: 120,
  },
  {
    title: 'Office Number',
    dataIndex: 'officeNumber',
    key: 'officeNumber',
    align: 'center',
    width: 120,
  },
  {
    title: 'Office Name',
    dataIndex: 'officeName',
    key: 'officeName',
    align: 'center',
    width: 120,
  },
  {
    title: 'Office ID',
    dataIndex: 'officeId',
    key: 'officeId',
    align: 'center',
    width: 120,
  },
];
